<template>
  <div class="user-admin ml-4 mr-4">
    <b-form>
      <input id="user-id" type="hidden" v-model="func.id" />
      <b-row>
        <b-col sm="1">
          <b-form-group label="Registro :" label-for="user-registro">
            <b-form-input
              id="user-registro"
              type="text"
              v-model="func.registro"
              required
              @keyup.enter="loadFuncionario()"
              readonly
              placeholder="Registro do funcionário"
            />
          </b-form-group>
        </b-col>

        <b-col sm="3">
          <b-form-group label="Nome:" label-for="user-nome">
            <b-form-input
              id="user-nome"
              type="text"
              v-model="func.nome"
              required
              readonly
              placeholder="Informe o Nome do Usuário..."
            />
          </b-form-group>
          <!--:readonly="mode === 'remove'" -->
        </b-col>

        <b-col sm="2">
          <b-form-group label="Função:" label-for="user-funcao">
            <b-form-input
              id="user-funcao"
              type="text"
              v-model="func.funcao"
              readonly
              placeholder="função..."
            />
          </b-form-group>
          <!--:readonly="mode === 'remove'" -->
        </b-col>

        <b-col sm="2">
          <b-form-group label="CPF:" label-for="user-cpf">
            <b-form-input
              id="user-cpf"
              type="text"
              v-model="func.cpf"
              required
              readonly
              placeholder="Informe o CPF do Usuário..."
            />
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <label for="input-parecer">Grupo de usuário</label>
          <div>
            <b-form-select
              id="grupo"
              v-model="func.id_grupo"
              :options="tpgrupos"
              class="mb-3"
              text-field="grupo"
            >
            </b-form-select>
          </div>
        </b-col>

        <!--                17/05/2023
            <b-form-checkbox class="mt-5" id="user-admin" v-show="mode === 'save'"
            v-model="func.admin">
              Administrador?   
          </b-form-checkbox>
        -->
      </b-row>

      <b-row v-show="mode === 'save'">
        <b-col sm="3">
          <b-form-group label="Senha:" label-for="user-password">
            <b-form-input
              id="user-password"
              type="password"
              v-model="func.password"
              required
              placeholder="Informe a senha do Usuário..."
            />
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group
            label="Confirmação de Senha:"
            label-for="user-confirm-password"
          >
            <b-form-input
              id="user-confirm-password"
              type="password"
              v-model="func.confirmPassword"
              required
              placeholder="Confirme a Senha do Usuário..."
            />
          </b-form-group>
        </b-col>

        <b-col cols="2">
          <b-form-checkbox
            id="vitimas"
            class="mb-3 mt-5"
            v-model="func.gestor"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
            checked="true"
          >
            Gestor
          </b-form-checkbox>
        </b-col>

        <b-col cols="4" class="mb-0">
          <label for="input-busca">Pesquisa no grid</label>
          <b-form-input
            id="buscaUsuario"
            v-model="search"
            required="required"
            placeholder="Registro ou Nome"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="4" class="mt-4">
          <b-button
            size="sm"
            variant="primary"
            class="mr-2 mt-3"
            v-if="mode === 'save'"
            @click="save"
            >Salvar</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            class="mr-2 mt-3"
            v-if="mode === 'remove'"
            @click="remove"
            >Excluir</b-button
          >
          <b-button size="sm" class="mr-2 mt-3" @click="reset"
            >Cancelar</b-button
          >
        </b-col>
      </b-row>
      <LoadingModal v-if="isLoading" />
    </b-form>
    <hr />

    <b-table
      small
      hover
      striped
      sticky-header="762px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          size="sm"
          variant="warning"
          @click="loadFunc(data.item)"
          class="mr-2"
        >
          <i class="fa fa-pencil"></i>
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          @click="loadFunc(data.item, 'remove')"
        >
          <i class="fa fa-trash"></i>
        </b-button>
      </template>
    </b-table>
    <b-pagination
      size="sm"
      v-model="page"
      :total-rows="count"
      :per-page="limit"
    ></b-pagination>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
import moment from "moment";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "UserAdmin",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valoresu = [];
      valoresu = this.funcs.filter((item) => {
        return (
          item.registro.indexOf(this.search) > -1 ||
          item.nome.indexOf(this.search.toUpperCase()) > -1
        );
      });
      return valoresu;
    },
  },

  data: function () {
    return {
      isLoading: false,
      mode: "save",
      func: {},
      funcs: [],
      tpgrupos: [],
      viacep: [],
      iporigem: [],
      search: "",

      page: 1,
      limit: 0,
      count: 0,

      fields: [
        { key: "id", label: "Id_usu", sortable: true },
        { key: "id_funcionario", label: "Código", sortable: true },
        // { key: 'id_funcionario_erp', label: 'Id_funcionario_erp', sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "nome", label: "Nome", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "grupo", label: "Grupo", sortable: true },
        {
          key: "gestor",
          label: "Gestor",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        //{ key: 'dt_cadastro', label: 'Data_Encerramento', sortable: true, formatter: (value, key, funcs) => {return moment(funcs.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

        {
          key: "dt_cadastro",
          label: "Data de Cadastro",
          sortable: true,
          formatter: (value, key, funcs) => {
            return moment(funcs.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },

        {
          key: "dt_atualizacao",
          label: "Data de atualização",
          sortable: true,
          formatter: (value, key, funcs) => {
            return moment(funcs.dt_atualizacao)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },

        //       { key: 'dt_cadastro', label: 'Data de cadastro', sortable: true },
        { key: "dt_cancelado", label: "Data de inativo", sortable: true },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: { LoadingModal },

  methods: {
    loadfuncs() {
      const url = `${baseApiUrl}/users`;
      axios.get(url).then((res) => {
        this.funcs = res.data;
      });
    },

    loadfuncs2() {
      this.isLoading = true; // Ative o indicador de carregamento
      let corpo = {
        id_empresa: `${[this.user.id_empresa]}`,
        id_grupo_empresa: `${[this.user.id_grupo_empresa]}`,
      };
      const url = `${baseApiUrl}/users/pg?page=${this.page}`;
      axios.post(url, corpo).then((res) => {
        this.funcs = res.data.data;
        this.isLoading = false; // Desative o indicador de carregamento
        this.count = res.data.count;
        this.limit = res.data.limit;
      });
    },

    reset() {
      //this.mode = 'save'
      this.func = {};
      this.loadfuncs2();
    },
    /*
        save2() {
            const method = this.func.id ? 'put' : 'post'
            const id = this.func.id ? `/${this.func.id}` : ''
            axios[method](`${baseApiUrl}/users${id}`, this.func)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadfuncs2()
                    //this.reset()
                })
                .catch(showError)
        },
*/

    save() {
      let corpo = {
        //"id_solicitacao": this.sacsolicitacao.id_solicitacao ? `${this.sacsolicitacao.id_solicitacao}`: this.idRetornoSolicitacao,
        id_empresa:
          this.func.id_empresa !== "" ? `${this.func.id_empresa}` : null,
        id_grupo_empresa:
          this.func.id_grupo_empresa !== ""
            ? `${this.func.id_grupo_empresa}`
            : null,
        id_empresa_erp:
          this.func.id_empresa_erp !== ""
            ? `${this.func.id_empresa_erp}`
            : null,
        id_filial_erp:
          this.func.id_filial_erp !== "" ? `${this.func.id_filial_erp}` : null,
        id_funcionario:
          this.func.id_funcionario !== ""
            ? `${this.func.id_funcionario}`
            : null,
        id_funcionario_erp:
          this.func.id_funcionario_erp !== ""
            ? `${this.func.id_funcionario_erp}`
            : null,
        id: this.func.id !== null ? `${this.func.id}` : null,
        cpf: this.func.cpf !== "" ? `${this.func.cpf}` : null,
        nome: `${this.func.nome}`,
        id_grupo: this.func.id_grupo > 0 ? `${this.func.id_grupo}` : null,
        gestor: this.func.gestor ? `${this.func.gestor}` : false,
        password: `${this.func.password}`,
        confirmPassword: `${this.func.confirmPassword}`,
        id_status: 1,
      };
      const url = `${baseApiUrl}/users`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          //this.loadfuncs2()
          this.reset(); //limpar os objetos valores
          //this.loadSacSolicitacoesTratativas()
          //this.loadSacSolicitacoes()
          //this.postNotificacao()
        })
        .catch(showError);
    },

    remove() {
      const id = this.func.id;
      axios
        .delete(`${baseApiUrl}/users/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
        })
        .catch(showError);
    },

    loadFunc(func, mode = "save") {
      this.mode = mode;
      this.func = { ...func };
      this.loadGrupo();
    },

    ////////////////////////////////

    loadFuncionario() {
      let corpo = {
        registro: `${[this.value_registro]}`,
      };

      const url = `${baseApiUrl}/users/funcionario/`;
      axios.post(url, corpo).then((res) => {
        this.func = res.data.map((func) => {
          return {
            registro: func.registro,
            nome: func.nome,
            cpf: func.cpf,
            gestor: func.gestor,
            id_funcionario: func.id_funcionario,
            id_funcionario_erp: func.id_funcionario_erp,
            admin: func.admin,
          };
        });
      });
    },

    loadCep() {
      axios.get("https://viacep.com.br/ws/08081320/json/").then((res) => {
        this.viacep = res.data;
      });
    },

    loadIpOrigem() {
      axios.get("https://ipinfo.io/json").then((res) => {
        this.iporigem = res.data;
      });
    },

    loadGrupo() {
      let corpo = {
        id_empresa: `${[this.user.id_empresa]}`,
      };
      const url = `${baseApiUrl}/users/grupo`;
      axios.post(url, corpo).then((res) => {
        this.tpgrupos = res.data.map((tpl) => {
          return { ...tpl, value: tpl.id_grupo, grupo: tpl.grupo };
        });
      });
    },
  },

  watch: {
    page() {
      this.loadfuncs2();
    },
  },

  mounted() {
    //this.loadfuncs(); // carrega usuario no grid
    this.loadfuncs2(); // carrega usuario no grid
    this.loadGrupo();
  },
};
</script>

<style>
.table {
  font-size: 0.7em;
}
</style>
